
; (function () {

    angular.module("EMR.Home")
        .service("EmrUtilityModelsService", emrUtilityModelService);

    emrUtilityModelService.$inject = ["EmrBaseModelChangesDoneApisList"];

    function emrUtilityModelService(EmrBaseModelChangesDoneApisList) {

        /** Variable used to restrict to data assignment to only once.*/
        var _isLocked = false;


        var _dbConnectivityModel = null;
        var _practiceDetailsModel = null;
        var _apiConnectivityModel = null;
        var _surescriptUrlModel = null;
        var _ccdaUrlModel = null;

        var service = {
            buildUtilityModels: buildUtilityModels,
            getDbConnectivityInfo: getDbConnectivityInfo,
            getPracticeDetailsInfo: getPracticeDetailsInfo,
            getApiConnectivityUrlInfo: getApiConnectivityUrlInfo,
            getSureScriptUrlInfo: getSureScriptUrlInfo,
            getCcdaUrlInfo: getCcdaUrlInfo,
            handleBaseModelChanges: handleBaseModelChanges
        };

        return service;

        //#region COMMON SERVICE IMPLEMENTATION
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
        //Added by Swaraj B on 01 Apr, 2021 as per Siva Prasad J
        function handleBaseModelChanges(data, url) {
            var apiName = getApiName(url),
                isApiModified = false;

            if (apiName && apiName.length && EmrBaseModelChangesDoneApisList && EmrBaseModelChangesDoneApisList.length) {
                isApiModified = EmrBaseModelChangesDoneApisList.indexOf(apiName) > -1;
            }

            //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
            //#region practice info properties changes
            //modified by Swaraj B on 06 Apr, 2022 - As per Uday Kiran sir...
            //at login we don't have _dbConnectivityModel initialized yet
            //so no need to append properties
            if (!_dbConnectivityModel) return data;

            let requestDataCopy, isListInput = false;

            //for some requests we use list as input
            if (angular.isArray(data) && data.length && data[0]) {
                requestDataCopy = { ...data[0] };
                isListInput = true;
            } else {
                requestDataCopy = { ...data };
            }

            //bind practice info
            requestDataCopy = bindBasicPracticeInfoProperties(requestDataCopy);
            //bind helpfile server ip
            bindHelpFileServerIpWhenNeeded(apiName, requestDataCopy);

            //as base model changes done for this api, need to supress practice model
            //but we are keeping basic properties to avoid errors for now (06 Apr, 2022)
            if (isApiModified) {
                //as base model changes completed
                //assigning db connectivity info
                if (requestDataCopy)
                    requestDataCopy = { ...requestDataCopy, ...getDbConnectivityInfo() };
                //instead of removing entire practice model
                //keeping basic practice information
                if (requestDataCopy && requestDataCopy.practicemodel && !requestDataCopy.isPracticeModelRequired) {
                    requestDataCopy.practicemodel = {};
                    requestDataCopy.practicemodel = bindBasicPracticeInfoProperties(requestDataCopy.practicemodel);
                }
            }

            if (isListInput) {
                data[0] = requestDataCopy;
            } else {
                data = requestDataCopy;
            }
            //#endregion
            //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//

            return data;
        }

        function bindHelpFileServerIpWhenNeeded(apiName, data) {
            if (apiName == "EHR_Help_Files_API_Net8" && data.practicemodel && data.practicemodel.emrurlsmodel && data.practicemodel.emrurlsmodel.HelpFileDBServerIP)
                data.HelpFileDBServerIP = data.practicemodel.emrurlsmodel.HelpFileDBServerIP;
        }
    
        function bindBasicPracticeInfoProperties(data){
            const basicPracticeInfoPropertiesCollection = ["ApplicationType", "DBServerName", "LoggedUserID", "PracticeID", "ReportsDBName"];
            basicPracticeInfoPropertiesCollection.forEach(function (property) {
                //as ApplicationType isn't available in _dbConnectivityModel
                //assigning manually
                if (property == "ApplicationType") {
                    data.ApplicationType = EMRPracticeModel.ApplicationType;
                    return;
                }
                //as we don't need to add the property which is already existing in request object
                if (!data.hasOwnProperty(property) && _dbConnectivityModel[property]) {
                    data[property] = _dbConnectivityModel[property];
                }
            });
            return data;
        }

    function getApiName(url) {
        url = url.replace("https://", "");
        url = url.replace("http://", "");
        var urlArr = url.split("/");
        if (urlArr && urlArr.length > 1) {
            if (url.indexOf("gateway") > -1)
                return urlArr[2];
            else return urlArr[1];
        }
        else return "";
    }

        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
        //#endregion

        //#region MODELS GETTING IMPLEMENTATION

        function getDbConnectivityInfo() {
            return _dbConnectivityModel;
        }

        function getPracticeDetailsInfo() {
            return _practiceDetailsModel;
        }

        function getApiConnectivityUrlInfo() {
            return _apiConnectivityModel;
        }

        function getSureScriptUrlInfo() {
            return _surescriptUrlModel;
        }

        function getCcdaUrlInfo() {
            return _ccdaUrlModel;
        }

        //#endregion

        //#region           MODULES UTILITY MODELS BUILDING IMPLEMENTATION
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
        //Added by Swaraj B on 27 Mar, 2021 as per Siva Prasad J


        /**
         * This method is used to build modules utility models from base model
         * This method is called from 'HomeController.js' after successful login to create this models
         * @param {any} practiceModel Practice information for the current practice.
         */
        function buildUtilityModels(practiceModel) {
            if (!practiceModel) return;
            if (_isLocked) return;
            _isLocked == true;

            buildDbConnectivityModel(practiceModel);

            buildPracticeDetailsModel(practiceModel);

            buildApiConnectivityUrlsModel(practiceModel);

            buildSurescriptRXUrlsModel(practiceModel);

            buildCcdaUrlModel(practiceModel);
        }



        function buildDbConnectivityModel(practiceModel) {
            if (!practiceModel) return;
            if (_dbConnectivityModel) return;
            _dbConnectivityModel = {
                DBServerName: practiceModel.DBServerName,
                PracticeID: practiceModel.PracticeID,
                LoggedUserID: practiceModel.LoggedUserID,
                ReportsDBName: practiceModel.ReportsDBName,
                FacilityIDForTempUse: practiceModel.LoggedFacilityID,//getting issue print letters format 2 with facility header
            };
        }

        function buildPracticeDetailsModel(practiceModel) {
            if (!practiceModel) return;
            if (_practiceDetailsModel) return;
            _practiceDetailsModel = {
                DBServerName: practiceModel.DBServerName,
                ReportsDBName: practiceModel.ReportsDBName,
                PracticeID: practiceModel.PracticeID,
                PracticeName: practiceModel.PracticeName,
                PracticeEntType: practiceModel.PracticeEntType,
                ApplicationType: practiceModel.ApplicationType,
                clientIP: practiceModel.clientIP,
                clientSystemLocalIP: practiceModel.clientSystemLocalIP,
                LoggedFacilityID: practiceModel.LoggedFacilityID,
                LoggedProgramId: practiceModel.LoggedProgramId,
                LoggedFacilityName: practiceModel.LoggedFacilityName,
                LoggedFacilityDisplayName: practiceModel.LoggedFacilityDisplayName,
            };
        }

        function buildApiConnectivityUrlsModel(practiceModel) {
            if (!practiceModel || !practiceModel.emrurlsmodel) return;
            if (_apiConnectivityModel) return;
            _apiConnectivityModel = {
                EMRWebWCFPrimaryExternalURL: practiceModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL,
                EMRWebWCFSecondaryExternalURL: practiceModel.emrurlsmodel.EMRWebWCFSecondaryExternalURL,
                EMRCentralizerSocketPrimaryURL: practiceModel.emrurlsmodel.EMRCentralizerSocketPrimaryURL,
                EMRCentralizerSocketSecondaryURL: practiceModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL,
                EHRCommonHelpFilesWCFExternalURLPrimary: practiceModel.emrurlsmodel.EHRCommonHelpFilesWCFExternalURLPrimary,
            };
        }

        function buildSurescriptRXUrlsModel(practiceModel) {
            if (!practiceModel || !practiceModel.emrurlsmodel) return;
            if (_surescriptUrlModel) return;
            _surescriptUrlModel = {
                EMRSureScript_ERxWebServiceURL: practiceModel.emrurlsmodel.EMRSureScript_ERxWebServiceURL,
                EMRSureScriptERXWEBAPI: practiceModel.emrurlsmodel.EMRSureScriptERXWEBAPI,
                EMRSureScriptERxSecondaryWebServiceURL: practiceModel.emrurlsmodel.EMRSureScriptERxSecondaryWebServiceURL,
                EMRSureScriptDirectoryWebServiceURL: practiceModel.emrurlsmodel.EMRSureScriptDirectoryWebServiceURL,
                EMRSureScriptMedHxWebServiceURL: practiceModel.emrurlsmodel.EMRSureScriptMedHxWebServiceURL,
                EMRSureScriptMedHxSecondaryWebServiceURL: practiceModel.emrurlsmodel.EMRSureScriptMedHxSecondaryWebServiceURL,
                EmrMedispanDataBaseConnetcingPrimaryServerUrl: practiceModel.emrurlsmodel.EmrMedispanDataBaseConnetcingPrimaryServerUrl,
                EmrMedispanDataBaseConnetcingSecondaryServerUrl: practiceModel.emrurlsmodel.EmrMedispanDataBaseConnetcingSecondaryServerUrl,
                EMRSureScriptERXWEBAPISecondaryURL: practiceModel.emrurlsmodel.EMRSureScriptERXWEBAPISecondaryURL,
                EMRSureScriptMedHxAPIPrimaryUrl: practiceModel.emrurlsmodel.EMRSureScriptMedHxAPIPrimaryUrl,
                EMRSureScriptMedHxAPISecondryUrl: practiceModel.emrurlsmodel.EMRSureScriptMedHxAPISecondryUrl,
            };
        }

        function buildCcdaUrlModel(practiceModel) {
            if (!practiceModel || !practiceModel.emrurlsmodel) return;
            if (_ccdaUrlModel) return;
            _ccdaUrlModel = {
                EMRSureScriptClinicalMessageWebServiceURL: practiceModel.emrurlsmodel.EMRSureScriptClinicalMessageWebServiceURL,
                EMRSureScriptClinicalMessagingWebServiceSecondaryURL: practiceModel.emrurlsmodel.EMRSureScriptClinicalMessagingWebServiceSecondaryURL,
            };
        }
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
        //#endregion
    }

})();